import { GDT_TYPES_MAP, gdtReport } from '../../lib/utils';

function Report() {
  gdtReport(GDT_TYPES_MAP.VIEW_CONTENT);
}

export default Report;
